import { all, put, takeEvery } from 'redux-saga/effects'

import { request } from '../../../1stlog-ui/src/utils'
import { receiveOrder } from './actions'
import { REQUEST_ORDER } from './constants'

export default function* root() {
  yield all([takeEvery(REQUEST_ORDER, handleRequestOrder)])
}

function* handleRequestOrder({ payload }) {
  try {
    const result = yield request({
      method: 'get',
      url: `/api/cronorder/${payload}`,
    })

    console.log(receiveOrder)
    yield put(receiveOrder({ result: result.data }))
  } catch (error) {
    yield put(receiveOrder({ error }))
  }
}
